import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PieChequesEnCarteraPorEmpresa from '../PieChequesEnCarteraPorEmpresa/PieChequesEnCarteraPorEmpresa';
import TablaMultiempresa from '../TablaMultiempresa/TablaMultiempresa';
import { fechaFinPeriodoMesActualFunc } from '../../../../shared/fechas';
import { storageMonedaSigno } from '../../../../shared/sessionData';
import { formatNumber } from '../../../../shared/formatNumber';
import * as actions from '../../../../store/actions/index';

const MultiChartChequesEnCarteraPorEmpresa = (props) => {
    const [viewAsPie, setViewAsPie] = useState(true);

    useEffect(() => {
        if (!props.estaCargado && !props.estaOculto && props.ejecucionDePagina) 
          props.onLoadChart();
        
    }, [props.ejecucionDePagina]);
    
    const handleChangeView = () => {
        setViewAsPie(!viewAsPie)
    }

    return(
        viewAsPie 
        ? 
            <PieChequesEnCarteraPorEmpresa 
                ejecucionDePagina={props.ejecucionDePagina}
                onPorcionClick={props.onPorcionClick}
                onChangeViewClick={handleChangeView}
                title={`Cheques en cartera por empresa al ${fechaFinPeriodoMesActualFunc()}`}
                subtitle={`Total: ${storageMonedaSigno()} ${formatNumber(props.totalCheques)}`}
                height={300}
                width={'100%'}
            />
        : 
            <TablaMultiempresa 
                empresas={props.cheques}
                onChangeViewClick={handleChangeView}
                title={`Cheques en cartera por empresa al ${fechaFinPeriodoMesActualFunc()}`}
                subtitle={`Total: ${storageMonedaSigno()} ${formatNumber(props.totalCheques)}`}
                height={245}
                width={'100%'}
            />
    )

}


const mapStateToProps = (state) => {
    return {
        loading: state.multiempresa.chequesEnCarteraPorEmpresa.loading,
        estaCargado: state.multiempresa.chequesEnCarteraPorEmpresa.estaCargado,
        estaOculto: state.configuraciones.indicadoresOcultosPorUsuario.indicadores.chequesEnCarteraMultiempresa,
        cheques: state.multiempresa.chequesEnCarteraPorEmpresa.cheques,
        totalCheques: state.multiempresa.chequesEnCarteraPorEmpresa.totalCheques
    }
}
  
const mapDispatchToProps = (dispatch) => {
    return {
      onLoadChart: () => dispatch(actions.loadChequesEnCarteraPorEmpresa())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MultiChartChequesEnCarteraPorEmpresa);
